// 活动参与
const zsxxwRoutes = Array.from({ length: 11 }, (_, i) => ({
  path: `activityParticipation/index${i + 1}`,
  name: `activityParticipation/Index${i + 1}`,
  component: () => import(`@/views/study/activityParticipation/index${i + 1}.vue`)
}))

export default {
  path: '/study',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [

    // 活动参与，开始
    ...zsxxwRoutes
    // 活动参与，结束

  ]
}
